import ListAltIcon from "@mui/icons-material/ListAlt";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  Box,
  ListItemIcon,
  MenuItem,
  Paper,
  Popover,
  Table,
  TableContainer,
} from "@mui/material";
import html2canvas from "html2canvas";
import React, { useCallback, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import CustomHead from "../../components/Common/CustomHead";
import Header from "../../components/Common/Header";
import Navbar from "../../components/Common/Navbar";
import { customDateConvert } from "../../components/Common/Utils/Utils";
import { useAuthContext } from "../../context/AuthProvider";
import useApi from "../../service/api.service";
import MatricesTableBody from "./Components/MatricesTableBody";
import MetricesTableHeader from "./Components/MetricesTableHeader";
import PercentageGraph from "./Components/PercentageGraph";
import RightContainer from "./Components/RightContainer";
import TableSkeleton from "../operator/Components/TableSkeleton";

function Summary() {
  const tableData = {
    columns: [
      "",
      "Part Based Factors",
      //   "UCL",
      //   "LCL",
      //  "Agv. σ %"
    ],
  };
  const { QCFull } = useAuthContext();
  const API = useApi();
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [downloadAllow, setDownloadAllow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingData1, setLoadingData1] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [chartData1, setChartData1] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [excelData1, setExcelData1] = useState([]);
  const [excelData2, setExcelData2] = useState([]);
  const [selectedLayout, setSelectedLayout] = useState("Overlay");
  const [selectedGranularity, setSelectedGranularity] = useState("Minute");

  const oneDay = 24 * 60 * 60 * 1000;
  const oneWeek = 7 * oneDay;
  const defaultStartDate = new Date(Date.now() - oneWeek);
  const defaultEndDate = new Date(Date.now() - oneDay);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
      enabled: false,
      status: false,
    },
  ]);
  const [finalDate, setFinalDate] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const handleSelectedItem = (selectedItemData) => {
    setSelectedRow(selectedItemData);
  };

  const getFactorsData = async () => {
    const requestBodyParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
    };
    try {
      setLoading(true);
      const response = await API.getFactorsData(requestBodyParams);
      setFilteredRows(
        response.data?.filter(
          (item) =>
            item.factorName !== "DRYINGTUNNEL_HOUR" &&
            item.factorName !== "DRYINGTUNNEL_MONTH"
        )
      );
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getFactorsData();
  }, [finalDate]);

  useEffect(() => {
    if (filteredRows.length > 0 && !selectedRow) {
      handleSelectedItem(filteredRows[0]);
    }
  }, [filteredRows]);

  const handleSelectedItemIds = useCallback(
    (selectedItemData) => {
      const selectedIds = selectedItemData.map((item) => item.factorId);
      setSelectedItemIds(selectedIds);
    },

    []
  );

  const startDate = finalDate.startDate
    ? new Date(finalDate.startDate)
    : defaultStartDate;
  const endDate = finalDate.endDate
    ? new Date(finalDate.endDate)
    : defaultEndDate;

  const captureRef = useRef(null);
  const takeScreenshot = () => {
    if (captureRef.current) {
      html2canvas(captureRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `Control Chart Factor From ${customDateConvert(
          startDate,
          "MM-DD-YYYY"
        )} To ${customDateConvert(endDate, "MM-DD-YYYY")}.png`;
        link.click();
      });
      toast.success("Data downloaded successfully");
    }
  };

  const captureRef1 = useRef(null);
  const takeScreenshot1 = () => {
    if (captureRef1.current) {
      html2canvas(captureRef1.current).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `Control Chart Factor From ${customDateConvert(
          startDate,
          "MM-DD-YYYY"
        )} To ${customDateConvert(endDate, "MM-DD-YYYY")}.png`;
        link.click();
      });
      toast.success("Data downloaded successfully");
    }
  };

  const fetchData = async () => {
    const body = {
      factorId: selectedItemIds?.[0],
      startDateTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endDateTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
    };

    try {
      setLoadingData(true);
      const response = await API.getBoxPlotChart(body);
      console.log(response?.data);
      setChartData(response?.data);
      setLoadingData(false);
    } catch (error) {
      setLoadingData(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchPercentData = async () => {
    const body = {
      startDateTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endDateTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
    };

    try {
      setLoadingData1(true);
      const response = await API.getPercentChart(body);
      console.log(response?.data);
      setChartData1(response?.data);
      setLoadingData1(false);
    } catch (error) {
      setLoadingData1(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        if (selectedItemIds.length > 0) {
          await fetchData();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDataAsync();
  }, [selectedItemIds]);

  useEffect(() => {
    fetchPercentData();
  }, [finalDate]);

  useEffect(() => {
    const download = chartData?.distributionData?.categories?.map(
      (data, index) => ({
        Count: data,
        "scrapped One Values":
          chartData?.distributionData?.scrappedOneValues?.[index],
        "scrapped Zero Values":
          chartData?.distributionData?.scrappedZeroValues?.[index],
      })
    );
    setExcelData({
      data: download,
      factorName: chartData?.distributionData?.factorName?.[0],
    });
    setExcelData1([
      {
        "Factor Name": chartData?.boxData?.categories?.[0],
        TheoreticalMean: chartData?.boxData?.TheoreticalMean,
        Minimum: chartData?.boxData?.values?.[0]?.[0],
        "Lower Quartile": chartData?.boxData?.values?.[0]?.[1],
        Median: chartData?.boxData?.values?.[0]?.[2],
        "Upper Quartile": chartData?.boxData?.values?.[0]?.[3],
        Maximum: chartData?.boxData?.values?.[0]?.[4],
      },
    ]);
  }, [chartData]);

  useEffect(() => {
    const download = chartData1?.categories?.map((data, index) => ({
      "Factor Name": data,
      "Percentage of variable Breaching Design Limits":
        chartData1?.values?.[index],
    }));
    setExcelData2(download);
  }, [chartData1]);

  const handleDownload = () => {
    const wb = XLSX.utils.book_new();

    const sheet1 = XLSX.utils.json_to_sheet(excelData?.data);
    setColumnWidths(sheet1, excelData?.data);
    const sheet2 = XLSX.utils.json_to_sheet(excelData1);
    setColumnWidths(sheet2, excelData1);
    const sheet3 = XLSX.utils.json_to_sheet(excelData2);
    setColumnWidths(sheet3, excelData2);
    XLSX.utils.book_append_sheet(wb, sheet1, excelData?.factorName);
    XLSX.utils.book_append_sheet(wb, sheet2, "boxPlotData");
    XLSX.utils.book_append_sheet(wb, sheet3, "variableBreachingDesignLimits");

    XLSX.writeFile(
      wb,
      `Summary Charts Data From ${customDateConvert(
        new Date(finalDate.endDate).toLocaleDateString("en-US"),
        "YYYY-MM-DD"
      )} To ${customDateConvert(
        new Date(finalDate.startDate).toLocaleDateString("en-US"),
        "YYYY-MM-DD"
      )}.xlsx`
    );
    toast.success("Data downloaded successfully");
  };

  const setColumnWidths = (worksheet, data) => {
    const columnHeaders = Object.keys(data[0]);
    const columnWidths = columnHeaders.map((header) => {
      const headerLength = header.length;
      const maxLength = data.reduce((max, row) => {
        const valueLength = row[header] ? row[header].toString().length : 0;
        return Math.max(max, valueLength);
      }, headerLength);
      return { wch: maxLength };
    });
    worksheet["!cols"] = columnWidths;
  };
  const [value, setValue] = useState(1);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenDownload = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      {!QCFull && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1000,
            width: "100%",
          }}
        >
          <Header />
          <Navbar />
        </div>
      )}
      <div
        style={{
          position: "fixed",
          top: QCFull ? "0px" : "102px",
          left: 0,
          zIndex: 1000,
          width: "100%",
          paddingTop: QCFull ? "0px" : "10px",
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: QCFull ? "100%" : "98%",
            mx: QCFull ? "0px" : "15px",
            boxSizing: "border-box",
            overflow: "auto",
          }}
        >
          <CustomHead
            title={"Summary Charts"}
            dateRange={dateRange}
            setDateRange={setDateRange}
            value={value}
            setValue={setValue}
            finalDate={finalDate}
            setFinalDate={setFinalDate}
            page={"Summary"}
            downloadPermission={false}
            setDownloadAllow={setDownloadAllow}
            selectedLayout={selectedLayout}
            setSelectedLayout={setSelectedLayout}
            selectedGranularity={selectedGranularity}
            setSelectedGranularity={setSelectedGranularity}
            handleOpenDownload={handleOpenDownload}
          />
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            sx={{ marginTop: "8px" }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                color: "#000",
                boxShadow: "#0000005f 0px 1px 12px",
                borderRadius: "5px",
              }}
            >
              <MenuItem
                onClick={() => {
                  takeScreenshot();
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <PictureAsPdfIcon fontSize="small" />
                </ListItemIcon>
                PDF
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleDownload();
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <ListAltIcon fontSize="small" />
                </ListItemIcon>
                CSV
              </MenuItem>
            </div>
          </Popover>
        </Box>
      </div>
      <Box
        ref={captureRef}
        sx={{
          display: "flex",
          width: QCFull ? "100%" : "98%",
          mx: "auto",
          gap: "1%",
          pt: 1,
          boxSizing: "border-box",
          // height: QCFull ? "100vh" : `calc(100vh - 110px)`,
          overflow: "auto",
          mt: QCFull ? "70px" : "175px",
        }}
      >
        <Paper
          sx={{
            display: "flex",
            width: "18%",
            borderRadius: "10px",
            flexDirection: "column",
            // height: "100%",
            boxShadow: "none",
          }}
        >
          <TableContainer
            sx={{
              width: "100%",
              maxHeight: QCFull ? "82vh" : "65vh",
              overflow: "auto",
              borderBottom: "1px solid #E4E4E4",
              borderRadius: "10px",
            }}
          >
            <Table aria-label="simple table" stickyHeader>
              <MetricesTableHeader tableData={tableData} />
              <MatricesTableBody
                data={filteredRows}
                onItemSelected={handleSelectedItem}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                onIdsSelected={handleSelectedItemIds}
                loading={loading}
              />
            </Table>
          </TableContainer>
        </Paper>
        <Paper
          sx={{
            width: "82%",
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
            boxShadow: "none",
          }}
        >
          <RightContainer data={chartData} loading={loadingData} />
        </Paper>
      </Box>
      <Box
        ref={captureRef1}
        sx={{
          display: "flex",
          width: QCFull ? "100%" : "98%",
          mx: "auto",
          gap: "1%",
          pt: QCFull ? 0 : 3,
          boxSizing: "border-box",
          // height: QCFull ? "100vh" : `calc(100vh - 110px)`,
          overflow: "auto",
          marginTop: QCFull ? "20px" : "0px",
        }}
      >
        {loadingData1 ? (
          <TableSkeleton width="300" />
        ) : (
        <Paper
          sx={{
            width: "100%",
            //   padding: "10px",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            // height: "100%",
            boxSizing: "border-box",
            fontWeight: 500,
            color: "#404040",
            boxShadow: "none",
            border: "1px solid #E4E4E4",
            overflowY: "auto",
          }}
        >
          <PercentageGraph
            actual={chartData1?.values}
            categories={chartData1?.categories}
          />
        </Paper>
        )}
      </Box>
    </>
  );
}

export default Summary;
